import { Stack, Typography } from "@mui/material";
import AcxSwitch from "components/UI/AcxSwitch";
import { observer } from "mobx-react";
import React from "react";
import { LLMClassifiersStore } from "../LLMClassifiers/Stores/LLMClassifiersStore";

interface ShowArchivedSwitchProps {
    store: LLMClassifiersStore;
}

export const ShowArchivedSwitch = observer(function (
    props: ShowArchivedSwitchProps,
) {
    return (
        <Stack
            direction="row"
            columnGap={1}
            flexWrap="nowrap"
            alignItems="center"
        >
            <AcxSwitch sx={{ margin: 0 }} checked={props.store.showArchived} />
            <Typography>Show Archived</Typography>
        </Stack>
    );
});
